import { motion } from "framer-motion";

/**
 * BreakingChains — minimalist SVG of two chain halves pulling apart with
 * ember sparks at the break point. Purely decorative, respects reduced motion.
 */
export default function BreakingChains({ className = "" }) {
  return (
    <svg
      viewBox="0 0 800 200"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      data-testid="breaking-chains-svg"
    >
      <defs>
        <filter id="chain-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="chain-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#555" />
          <stop offset="1" stopColor="#FF4D00" />
        </linearGradient>
      </defs>

      {/* left chain */}
      <motion.g
        initial={{ x: 0 }}
        animate={{ x: -20 }}
        transition={{ duration: 4, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <ellipse
            key={"l" + i}
            cx={60 + i * 54}
            cy={100}
            rx={24}
            ry={14}
            fill="none"
            stroke="url(#chain-grad)"
            strokeWidth="3"
            opacity={0.35 + i * 0.1}
          />
        ))}
      </motion.g>

      {/* right chain */}
      <motion.g
        initial={{ x: 0 }}
        animate={{ x: 20 }}
        transition={{ duration: 4, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <ellipse
            key={"r" + i}
            cx={460 + i * 54}
            cy={100}
            rx={24}
            ry={14}
            fill="none"
            stroke="url(#chain-grad)"
            strokeWidth="3"
            opacity={0.75 - i * 0.1}
          />
        ))}
      </motion.g>

      {/* break flash */}
      <motion.circle
        cx={400}
        cy={100}
        r={8}
        fill="#FF4D00"
        filter="url(#chain-glow)"
        animate={{ opacity: [0.6, 1, 0.6], r: [8, 14, 8] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.circle
        cx={400}
        cy={100}
        r={24}
        fill="none"
        stroke="#FF4D00"
        strokeWidth="1"
        opacity={0.35}
        animate={{ r: [24, 60], opacity: [0.4, 0] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
      />

      {/* sparks */}
      {[...Array(8)].map((_, i) => (
        <motion.circle
          key={i}
          cx={400}
          cy={100}
          r={1.2}
          fill={i % 3 === 0 ? "#00F0FF" : "#FF7A3A"}
          animate={{
            cx: [400, 400 + Math.cos((i / 8) * Math.PI * 2) * 140],
            cy: [100, 100 + Math.sin((i / 8) * Math.PI * 2) * 60 + 20],
            opacity: [1, 0],
          }}
          transition={{
            duration: 1.8,
            repeat: Infinity,
            delay: i * 0.18,
            ease: "easeOut",
          }}
        />
      ))}
    </svg>
  );
}
